
export enum PrecatorioStatus {
  Pendente = "Pendente",
  Precificando = "Precificando",
  Precificado = "Precificado"
}



// WEBPACK FOOTER //
// ./src/services/interfaces/PrecatorioStatus.ts